import {
    CATEGORY_DETAILS,
    INFORMATION_ABOUT_THE_RADIO_COM_EQUIPMENT_SETUP,
    OTHER_DETAILS,
    STATION_DETAILS,
    SUPPORTING_DOCUMENTS
} from 'common/application.const/Licence/MyLicence/LRSLicence';
import { attachmentPayloadSetting, attachmentRetrieve, requestLicenceAttachment } from 'features/applicationPage/helpers';
import {
    LICENCE_DETAILS as CANCEL_LICENCE_DETAILS,
    SUPPORTING_DOCUMENTS as CANCEL_SUPPORTING_DOCUMENTS
} from 'common/application.const/Licence/MyApplication/cancelLicence';
import { SUPPORTING_DOCUMENTS as AMEND_SUPPORTING_DOCUMENTS } from 'common/application.const/Licence/MyApplication/amendLicence';
import { LICENCE_DETAILS as RENEW_LICENCE_DETAILS } from 'common/application.const/Licence/MyApplication/renewLicence';
import { formatDateTo_ddMMyyyy } from 'utils/application.helpers';

export const formatLRSApplication = async (licenceDetails: any, caseTypeID: string, application?: string, transactionType?: any) => {
    let licence;
    let newDocs;
    let newPayload;
    let docsLic;
    let baseLandFixedStationInfo = [];
    let mobilePortableStationInfo = [];

    newDocs = [];
    for (const key in licenceDetails.LICSupportingDoc) {
        if (licenceDetails.LICSupportingDoc.hasOwnProperty(key)) {
            const doc = await requestLicenceAttachment(licenceDetails.LICSupportingDoc[key], caseTypeID);
            if (doc.ID) {
                const attachment = {
                    ID: doc.ID,
                    fileName: doc.fileName,
                    mimeType: doc.mimeType,
                    category: doc.category
                };
                newDocs.push(attachment);
            }
        }
    }

    newPayload = attachmentPayloadSetting(newDocs);
    docsLic = attachmentRetrieve(newPayload);

    if (licenceDetails && licenceDetails.baseLandFixedStationInfo && licenceDetails.baseLandFixedStationInfo.length > 0) {
        baseLandFixedStationInfo = licenceDetails?.baseLandFixedStationInfo
            ?.map((value: any, index: number) => ({
                'area-of-operation': value?.areaOfOperation ?? '-',
                'call-sign': value?.callSign ?? '-',
                'location-of-station': value?.locationOfStationEGRooftop ?? '-',
                'station-name': value?.stationName ?? '-',
                'building-name': value?.stationAddress?.buildingName ?? '-',
                'postal-code': value?.stationAddress?.postalCode ?? '-',
                'street-name': value?.stationAddress?.streetName ?? '-',
                'block-house-no': value?.stationAddress?.blockNo ?? '-',
                unit: value?.stationAddress?.unit ?? '-',
                'floor-level': value?.stationAddress?.floor ?? '-',
                'latitude-degrees': value?.latitudeDegrees ?? '-',
                'latitude-minutes': value?.latitudeMinutes ?? '-',
                'latitude-seconds': value?.latitudeSeconds ?? '-',
                'longitude-degrees': value?.longitudeDegrees ?? '-',
                'longitude-minutes': value?.longitudeMinutes ?? '-',
                'longitude-seconds': value?.longitudeSeconds ?? '-',
                'building-height-m': value?.buildingHeightM ?? '-',
                'antenna-effective-height-m-above-ground-level-station': value?.stationAntennaEffectiveHeightMAboveGroundLevel ?? '-',
                'elevation-angle-station': value?.stationElevationAngle ?? '-',
                'radius-of-operation-km': value?.radiusOfOperationKm ?? '-',
                'vendor-name': value?.vendorName ?? '-',
                'vendor-licence-number': value?.vendorLicenceNumber ?? '-',
                'contact-person': value?.contactPerson ?? '-',
                'contact-number': value?.ContactNumber ?? '-',
                'do-you-have-an-address-for-the-vendor': value?.doYouHaveAnAddressForTheVendor ?? 'No',
                'vendor-building-name': value?.vendorAddress?.buildingName ?? '-',
                'vendor-postal-code': value?.vendorAddress?.postalCode ?? '-',
                'vendor-street-name': value?.vendorAddress?.streetName ?? '-',
                'vendor-block-house-no': value?.vendorAddress?.blockNo ?? '-',
                'vendor-unit': value?.vendorAddress?.unit ?? '-',
                'vendor-floor-level': value?.vendorAddress?.floor ?? '-',
                'manufacturer-transmitter': value?.manufacturerTransmitter ?? '-',
                'manufacturer-receiver': value?.manufacturerReceiver ?? '-',
                'model-transmitter': value?.modelTransmitter ?? '-',
                'model-receiver': value?.modelReceiver ?? '-',
                'output-power-w-transmitter': value?.outputPowerWTransmitter ?? '-',
                'antenna-manufacturer': value?.manufacturer ?? '-',
                'antenna-effective-height-m-above-ground-level': value?.antennaEffectiveHeightMAboveGroundLevel ?? '-',
                'elevation-angle': value?.elevationAngle ?? '-',
                polarization: value?.polarization ?? '-',
                'gain-db': value?.gainDB ?? '-',
                model: value?.model ?? '-',
                'tuned-frequency-mhz': value?.tunedFrequencyMHz ?? '-',
                'antenna-tuned-frequency-mhz': value?.antennaTunedFrequencyMHz ?? '-',
                'frequency-and-emission-class-information':
                    value?.frequencyAndEmissionClassInformation.map((i: any) => {
                        return {
                            'desired-frequency-mhz-from-tx': i.desiredFrequencyMHzFromTransmit ?? '-',
                            'desired-frequency-mhz-to-tx': i.desiredFrequencyMHzToTransmit ?? '-',
                            'desired-frequency-mhz-from-rx': i.desiredFrequencyMHzFromReceive ?? '-',
                            'desired-frequency-mhz-to-rx': i.desiredFrequencyMHzToReceive ?? '-',
                            'desired-bandwidth-khz-tx': i.bandwidthKHzTransmit ?? '-',
                            'desired-bandwidth-khz-rx': i.bandwidthKHzReceive ?? '-',

                            'assigned-frequency-mhz-from-tx': i.assignedFrequencyMHzFromTransmit ?? '-',
                            'assigned-frequency-mhz-to-tx': i.assignedFrequencyMHzToTransmit ?? '-',
                            'assigned-frequency-mhz-from-rx': i.assignedFrequencyMHzFromReceive ?? '-',
                            'assigned-frequency-mhz-to-rx': i.assignedFrequencyMHzToReceive ?? '-',
                            'assigned-bandwidth-khz-tx': i.AssignedBandwidthTx ?? '-',
                            'assigned-bandwidth-khz-rx': i.AssignedBandwidthRx ?? '-',

                            'start-time': i.startTime ?? '-',
                            'stop-time': i.stopTime ?? '-',

                            'emission-class': i.emissionClass ?? '-',
                            'output-power-req': i.Power ?? '-',
                            power: i.Power ?? '-',
                            'power-unit': i.PowerUnit ?? '-',
                            'frequency-entry-tx': i?.FrequencyEntryTx ?? '-',
                            'frequency-entry-rx': i?.FrequencyEntryRx ?? '-'
                        };
                    }) ?? '-'
            }))
            .map((item: any, index: number) => {
                if (index === 0) {
                    return item;
                }
                return {
                    [`area-of-operation-${index}`]: item['area-of-operation'],
                    [`call-sign-${index}`]: item['call-sign'],
                    [`location-of-station-${index}`]: item['location-of-station'],
                    [`station-name-${index}`]: item['station-name'],
                    [`building-name-${index}`]: item['building-name'],
                    [`postal-code-${index}`]: item['postal-code'],
                    [`street-name-${index}`]: item['street-name'],
                    [`block-house-no-${index}`]: item['block-house-no'],
                    [`unit-${index}`]: item['unit'],
                    [`floor-level-${index}`]: item['floor-level'],
                    [`latitude-degrees-${index}`]: item['latitude-degrees'],
                    [`latitude-minutes-${index}`]: item['latitude-minutes'],
                    [`latitude-seconds-${index}`]: item['latitude-seconds'],
                    [`longitude-degrees-${index}`]: item['longitude-degrees'],
                    [`longitude-minutes-${index}`]: item['longitude-minutes'],
                    [`longitude-seconds-${index}`]: item['longitude-seconds'],
                    [`building-height-m-${index}`]: item['building-height-m'],
                    [`antenna-effective-height-m-above-ground-level-station${index}`]:
                        item['antenna-effective-height-m-above-ground-level-station'],
                    [`elevation-angle-station${index}`]: item['elevation-angle-station'],
                    [`radius-of-operation-km-${index}`]: item['radius-of-operation-km'],
                    [`vendor-name-${index}`]: item['vendor-name'],
                    [`vendor-licence-number-${index}`]: item['vendor-licence-number'],
                    [`contact-person-${index}`]: item['contact-person'],
                    [`contact-number-${index}`]: item['contact-number'],
                    [`vendor-building-name-${index}`]: item['vendor-building-name'],
                    [`vendor-postal-code-${index}`]: item['vendor-postal-code'],
                    [`vendor-street-name-${index}`]: item['vendor-street-name'],
                    [`vendor-block-house-no-${index}`]: item['vendor-block-house-no'],
                    [`vendor-unit-${index}`]: item['vendor-unit'],
                    [`vendor-floor-level-${index}`]: item['vendor-floor-level'],
                    [`do-you-have-an-address-for-the-vendor-${index}`]: item['do-you-have-an-address-for-the-vendor'],
                    [`manufacturer-transmitter-${index}`]: item['manufacturer-transmitter'],
                    [`manufacturer-receiver-${index}`]: item['manufacturer-receiver'],
                    [`model-transmitter-${index}`]: item['model-transmitter'],
                    [`model-receiver-${index}`]: item['model-receiver'],
                    [`output-power-w-transmitter-${index}`]: item['output-power-w-transmitter'],
                    [`antenna-manufacturer-${index}`]: item['antenna-manufacturer'],
                    [`antenna-effective-height-m-above-ground-level-${index}`]: item['antenna-effective-height-m-above-ground-level'],
                    [`elevation-angle${index}`]: item['elevation-angle'],
                    [`polarization-${index}`]: item['polarization'],
                    [`gain-db-${index}`]: item['gain-db'],
                    [`model-${index}`]: item['model'],
                    [`tuned-frequency-mhz-${index}`]: item['tuned-frequency-mhz'],
                    [`antenna-tuned-frequency-mhz-${index}`]: item['antenna-tuned-frequency-mhz'],
                    [`frequency-and-emission-class-information-${index}`]: item['frequency-and-emission-class-information']
                };
            });
    }

    if (licenceDetails && licenceDetails.mobilePortableStationInfo && licenceDetails.mobilePortableStationInfo.length > 0) {
        mobilePortableStationInfo = licenceDetails?.mobilePortableStationInfo
            ?.map((value: any, index: number) => ({
                'area-of-operation': value?.areaOfOperation ?? '-',
                'call-sign': value?.callSign ?? '-',
                'station-name': value?.stationName ?? '-',
                'building-name': value?.address?.buildingName ?? '-',
                'postal-code': value?.address?.postalCode ?? '-',
                'street-name': value?.address?.streetName ?? '-',
                'block-house-no': value?.address?.blockNo ?? '-',
                unit: value?.address?.unit ?? '-',
                'floor-level': value?.address?.floor ?? '-',
                'latitude-degrees': value?.latitudeDegrees ?? '-',
                'latitude-minutes': value?.latitudeMinutes ?? '-',
                'latitude-seconds': value?.latitudeSeconds ?? '-',
                'longitude-degrees': value?.longitudeDegrees ?? '-',
                'longitude-minutes': value?.longitudeMinutes ?? '-',
                'longitude-seconds': value?.longitudeSeconds ?? '-',
                'area-of-operation-line-1': value?.areaOfOperationLine1 ?? '-',
                'area-of-operation-line-2': value?.areaOfOperationLine2 ?? '-',
                'area-of-operation-line-3': value?.areaOfOperationLine3 ?? '-',
                'no-of-mobiles': value?.noOfMobiles ?? '-',
                'mobile-communication-with': value?.mobileCommunicationWith ?? '-',
                'coverage-information': value?.coverageInformation ?? '-',
                'manufacturer-transmitter': value?.manufacturerTransmitter ?? '-',
                'manufacturer-receiver': value?.manufacturerReceiver ?? '-',
                'model-transmitter': value?.modelTransmitter ?? '-',
                'model-receiver': value?.modelReceiver ?? '-',
                'output-power-w-transmitter': value?.outputPowerWTransmitter ?? '-',
                'mobile-station-frequency-info':
                    value?.mobileStationFrequencyInfo.map((i: any) => {
                        return {
                            'id-no': index + 1,
                            'desired-frequency-mhz-from-tx': i.desiredFrequencyMHzFromTransmit ?? '-',
                            'desired-frequency-mhz-to-tx': i.desiredFrequencyMHzToTransmit ?? '-',
                            'desired-frequency-mhz-from-rx': i.desiredFrequencyMHzFromReceive ?? '-',
                            'desired-frequency-mhz-to-rx': i.desiredFrequencyMHzToReceive ?? '-',
                            'desired-bandwidth-khz-tx': i.bandwidthKHzTransmit ?? '-',
                            'desired-bandwidth-khz-rx': i.bandwidthKHzReceive ?? '-',

                            'assigned-frequency-mhz-from-tx': i.assignedFrequencyMHzFromTransmit ?? '-',
                            'assigned-frequency-mhz-to-tx': i.assignedFrequencyMHzToTransmit ?? '-',
                            'assigned-frequency-mhz-from-rx': i.assignedFrequencyMHzFromReceive ?? '-',
                            'assigned-frequency-mhz-to-rx': i.assignedFrequencyMHzToReceive ?? '-',
                            'assigned-bandwidth-khz-tx': i.AssignedBandwidthRx ?? '-',
                            'assigned-bandwidth-khz-rx': i.AssignedBandwidthTx ?? '-',

                            'emission-class-tx': i.emissionClassTransmit ?? '-',
                            'emission-class-rx': i.emissionClassReceive ?? '-',

                            'start-time': i.startTime ?? '-',
                            'stop-time': i.stopTime ?? '-',

                            power: i.Power ?? '-',
                            'power-unit': i.PowerUnit ?? '-',
                            'frequency-entry-tx': i?.FrequencyEntryTx ?? '-',
                            'frequency-entry-rx': i?.FrequencyEntryRx ?? '-'
                        };
                    }) ?? '-'
            }))
            .map((item: any, index: number) => {
                if (index === 0) {
                    return item;
                }
                return {
                    [`area-of-operation-${index}`]: item['area-of-operation'],
                    [`call-sign-${index}`]: item['call-sign'],
                    [`station-name-${index}`]: item['station-name'],
                    [`building-name-${index}`]: item['building-name'],
                    [`postal-code-${index}`]: item['postal-code'],
                    [`street-name-${index}`]: item['street-name'],
                    [`block-house-no-${index}`]: item['block-house-no'],
                    [`unit-${index}`]: item['unit'],
                    [`floor-level-${index}`]: item['floor-level'],
                    [`latitude-degrees-${index}`]: item['latitude-degrees'],
                    [`latitude-minutes-${index}`]: item['latitude-minutes'],
                    [`latitude-seconds-${index}`]: item['latitude-seconds'],
                    [`longitude-degrees-${index}`]: item['longitude-degrees'],
                    [`longitude-minutes-${index}`]: item['longitude-minutes'],
                    [`longitude-seconds-${index}`]: item['longitude-seconds'],
                    [`area-of-operation-line-1-${index}`]: item['area-of-operation-line-1'],
                    [`area-of-operation-line-2-${index}`]: item['area-of-operation-line-2'],
                    [`area-of-operation-line-3-${index}`]: item['area-of-operation-line-3'],
                    [`no-of-mobiles-${index}`]: item['no-of-mobiles'],
                    [`mobile-communication-with-${index}`]: item['mobile-communication-with'],
                    [`coverage-information-${index}`]: item['coverage-information'],
                    [`manufacturer-transmitter-${index}`]: item['manufacturer-transmitter'],
                    [`manufacturer-receiver-${index}`]: item['manufacturer-receiver'],
                    [`model-transmitter-${index}`]: item['model-transmitter'],
                    [`model-receiver-${index}`]: item['model-receiver'],
                    [`output-power-w-transmitter-${index}`]: item['output-power-w-transmitter'],
                    [`mobile-station-frequency-info-${index}`]: item['mobile-station-frequency-info']
                };
            });
    }

    licence = {
        id: 'localised-radio-com',
        formID: 'localised-radio-com',
        hasError: true,
        title: application === 'IMDA-IRIS-Work-LICApplication' ? 'Application Details' : 'Licence Details',
        values: {
            [`${CATEGORY_DETAILS}-licence-category`]: licenceDetails?.LicenceCategoryDetails?.pleaseSelectTheLicenceYouWishToApply ?? '-',

            [`${INFORMATION_ABOUT_THE_RADIO_COM_EQUIPMENT_SETUP}-purpose-of-communication`]:
                licenceDetails?.informationAboutTheRadioComEquipmentSetup?.purposeOfCommunication ?? '-',
            [`${INFORMATION_ABOUT_THE_RADIO_COM_EQUIPMENT_SETUP}-is-this-fixed-station-located-at-the-above-building-either-owned-or-occupied-by-you`]:
                licenceDetails?.informationAboutTheRadioComEquipmentSetup?.locationOfFixedStationS ?? '-',
            [`${INFORMATION_ABOUT_THE_RADIO_COM_EQUIPMENT_SETUP}-is-the-above-building-separated-by-public-road-canal-etc`]:
                licenceDetails?.informationAboutTheRadioComEquipmentSetup?.isTheAboveBuildingSSeparatedByPublicRoadSCanalSEtc ?? '-',
            [`${INFORMATION_ABOUT_THE_RADIO_COM_EQUIPMENT_SETUP}-building-within-the-same-premises`]:
                licenceDetails?.informationAboutTheRadioComEquipmentSetup?.buildingWithinTheSamePremises ?? '-',
            [`${INFORMATION_ABOUT_THE_RADIO_COM_EQUIPMENT_SETUP}-intra-corporate-communication`]:
                licenceDetails?.informationAboutTheRadioComEquipmentSetup?.intraCorporateCommunication ?? '-',
            [`${INFORMATION_ABOUT_THE_RADIO_COM_EQUIPMENT_SETUP}-does-the-mobile-station-operate-within-the-same-premises-or-in-confined-areas-ie-no-public-road-canal-etc-in-the-area-of-operation`]:
                licenceDetails?.informationAboutTheRadioComEquipmentSetup?.mobileStationSOperation ?? '-',
            [`${INFORMATION_ABOUT_THE_RADIO_COM_EQUIPMENT_SETUP}-equipment-compliance-with-imda-ts-srd`]:
                licenceDetails?.informationAboutTheRadioComEquipmentSetup?.equipmentComplianceWithImdaTsSrd ?? '-',

            [`${OTHER_DETAILS}-proposed-use-of-system`]: licenceDetails?.otherDetails?.proposedUseOfSystem ?? '-',
            [`${OTHER_DETAILS}-remarks`]: licenceDetails?.otherDetails?.remarks ?? '-',

            [`${STATION_DETAILS}-station-tabs`]: [
                { 'fixed-station-licence': [...baseLandFixedStationInfo] },
                { 'mobile-station-licence': [...mobilePortableStationInfo] }
            ],

            [`${SUPPORTING_DOCUMENTS}-supporting-documents`]: newDocs ? docsLic : undefined
        }
    };

    if (transactionType === 'Cancel') {
        licence = {
            id: 'cancel-licence-details',
            formID: 'cancel-licence-details',
            hasError: true,
            title: application === 'IMDA-IRIS-Work-LICApplication' ? 'Application Details' : 'Station and Equipment Details',
            values: {
                [`${CANCEL_LICENCE_DETAILS}-licensee-nric`]: licenceDetails?.licenceDetails?.licenseeNric ?? '',
                [`${CANCEL_LICENCE_DETAILS}-registration-no-uen-other`]: licenceDetails?.licenceDetails?.uen ?? '',
                [`${CANCEL_LICENCE_DETAILS}-licence-no`]: licenceDetails?.licenceDetails?.licenceNumber ?? '',

                [`${CANCEL_LICENCE_DETAILS}-cancellationReason`]: licenceDetails?.cancellationInformation?.cancellationReason ?? '',
                [`${CANCEL_LICENCE_DETAILS}-effectiveDateOfCancellation`]:
                    formatDateTo_ddMMyyyy(licenceDetails?.cancellationInformation?.effectiveDateOfCancellation) ?? '',

                [`${CANCEL_SUPPORTING_DOCUMENTS}-supporting-documents`]: newDocs ? docsLic : '-'
            }
        };
    }

    if (transactionType === 'Renew') {
        licence = {
            id: 'renew-licence-details',
            formID: 'renew-licence-details',
            hasError: true,
            title: application === 'IMDA-IRIS-Work-LICApplication' ? 'Application Details' : 'Station and Equipment Details',
            values: {
                [`${RENEW_LICENCE_DETAILS}-licensee-nric`]: licenceDetails?.licenceDetails?.licenseeNric ?? '',
                [`${RENEW_LICENCE_DETAILS}-registration-no-uen-other`]: licenceDetails?.licenceDetails?.uen ?? '',
                [`${RENEW_LICENCE_DETAILS}-licence-no`]: licenceDetails?.licenceDetails?.licenceNumber ?? '',

                [`${RENEW_LICENCE_DETAILS}-invoiceNo`]: licenceDetails?.licenceRenewal?.invoiceNumber ?? '',
                [`${RENEW_LICENCE_DETAILS}-renewalAmount`]: licenceDetails?.licenceRenewal?.renewalAmount ?? '',
                [`${RENEW_LICENCE_DETAILS}-giroIndicator`]: licenceDetails?.licenceRenewal?.giroIndicator ?? '',
                [`${RENEW_LICENCE_DETAILS}-dateOfExpiry`]: formatDateTo_ddMMyyyy(licenceDetails?.licenceRenewal?.dateOfExpiry) ?? '',
                [`${RENEW_LICENCE_DETAILS}-paymentDueDate`]: formatDateTo_ddMMyyyy(licenceDetails?.licenceRenewal?.paymentDueDate) ?? '',
                [`${RENEW_LICENCE_DETAILS}-renewalPeriod`]: licenceDetails?.licenceRenewal?.renewalPeriod ?? ''
            }
        };
    }

    if (transactionType === 'Amend') {
        const mapped = (
            licenceDetails?.iwantToAmend ||
            licenceDetails?.licenceDetails?.iwantToAmend ||
            licenceDetails?.iWantToUpdate ||
            licenceDetails?.licenceDetails?.iWantToUpdate
        )?.map((data: { [key: string]: string }) => {
            return {
                type: data.mixedValue
            };
        });

        licence = {
            id: 'amend-localised-radio-com',
            formID: 'amend-localised-radio-com',
            hasError: true,
            title: application === 'IMDA-IRIS-Work-LICApplication' ? 'Application Details' : 'Station and Equipment Details',
            values: {
                [`${CATEGORY_DETAILS}-amend-table`]: Array.isArray(mapped) && mapped.length > 0 ? [...mapped] : [],
                [`${CATEGORY_DETAILS}-licence-category`]:
                    licenceDetails?.LicenceCategoryDetails?.pleaseSelectTheLicenceYouWishToApply ?? '',

                [`${INFORMATION_ABOUT_THE_RADIO_COM_EQUIPMENT_SETUP}-purpose-of-communication`]:
                    licenceDetails?.informationAboutTheRadioComEquipmentSetup?.purposeOfCommunication ?? '',
                [`${INFORMATION_ABOUT_THE_RADIO_COM_EQUIPMENT_SETUP}-is-this-fixed-station-located-at-the-above-building-either-owned-or-occupied-by-you`]:
                    licenceDetails?.informationAboutTheRadioComEquipmentSetup?.locationOfFixedStationS ?? '',
                [`${INFORMATION_ABOUT_THE_RADIO_COM_EQUIPMENT_SETUP}-is-the-above-building-separated-by-public-road-canal-etc`]:
                    licenceDetails?.informationAboutTheRadioComEquipmentSetup?.isTheAboveBuildingSSeparatedByPublicRoadSCanalSEtc ?? '',
                [`${INFORMATION_ABOUT_THE_RADIO_COM_EQUIPMENT_SETUP}-building-within-the-same-premises`]:
                    licenceDetails?.informationAboutTheRadioComEquipmentSetup?.buildingWithinTheSamePremises ?? '',
                [`${INFORMATION_ABOUT_THE_RADIO_COM_EQUIPMENT_SETUP}-intra-corporate-communication`]:
                    licenceDetails?.informationAboutTheRadioComEquipmentSetup?.intraCorporateCommunication ?? '',
                [`${INFORMATION_ABOUT_THE_RADIO_COM_EQUIPMENT_SETUP}-does-the-mobile-station-operate-within-the-same-premises-or-in-confined-areas-ie-no-public-road-canal-etc-in-the-area-of-operation`]:
                    licenceDetails?.informationAboutTheRadioComEquipmentSetup?.mobileStationSOperation ?? '',
                [`${INFORMATION_ABOUT_THE_RADIO_COM_EQUIPMENT_SETUP}-equipment-compliance-with-imda-ts-srd`]:
                    licenceDetails?.informationAboutTheRadioComEquipmentSetup?.equipmentComplianceWithImdaTsSrd ?? '',

                [`${OTHER_DETAILS}-proposed-use-of-system`]: licenceDetails?.otherDetails?.proposedUseOfSystem ?? '',
                [`${OTHER_DETAILS}-remarks`]: licenceDetails?.otherDetails?.remarks ?? '',

                [`${STATION_DETAILS}-station-tabs`]: [
                    { 'fixed-station-licence': [...baseLandFixedStationInfo] },
                    { 'mobile-station-licence': [...mobilePortableStationInfo] }
                ],

                [`${AMEND_SUPPORTING_DOCUMENTS}-supporting-documents`]: newDocs ? docsLic : undefined
            }
        };
    }

    return licence;
};

const lrsApplicationPayload = {
    formatLRSApplication
};

export default lrsApplicationPayload;
